import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

const MANAGEMENT_API_URL = environment.api_url + "/management";

const headers = new HttpHeaders({
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": environment.api_url,
  "Access-Control-Allow-Headers": "Origin, Content-Type, Content-Length, X-Auth-Token, Accept, Authorization, X-Request-With, Access-Control-Request-Method, Access-Control-Request-Headers",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT",
});

@Injectable({
  providedIn: 'root'
})
export class ManagementService {

  constructor(private http: HttpClient){}

  saveWhitelistEntry(whitelistEntry: any){
    return this.http.post(MANAGEMENT_API_URL + "/whitelist/save", whitelistEntry, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }
  getWhitelist(limit: any): Observable<any> {
    return this.http.post<any>(MANAGEMENT_API_URL + "/whitelist/list", limit, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }
  deleteWhitelistEntry(id: number){
    return this.http.get(MANAGEMENT_API_URL + "/whitelist/delete?id=" + id, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }
  
  getWhitelistLength(): Observable<any> {
    return this.http.get<any>(MANAGEMENT_API_URL + "/whitelist/length", {headers})
      .pipe(
        catchError(this.handleError)
      )
  }

  getLoggedUser(): Observable<any>{
    return this.http.get(`${environment.api_url}/user/loggedUser`, {headers})
      .pipe(
        catchError(this.handleError)
      )
  }

  logoutUser(): Observable<any>{
    return this.http.get(`${environment.api_url}/user/logout`, { headers, responseType: 'text' as 'json' })
      .pipe(
        catchError(this.handleError)
      )
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) errorMessage = error.error.message;
    else errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    console.log(errorMessage);
    return throwError(() => { return errorMessage; });
  }

  changeScheduler(timeExpr: string, taskName: string){
    return this.http.get(MANAGEMENT_API_URL + "/changeScheduler?timeExpr=" + timeExpr + "&taskName=" + taskName, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }

  getPropertiesLength(): Observable<any> {
    return this.http.get<any>(MANAGEMENT_API_URL + "/properties/length", {headers})
      .pipe(
        catchError(this.handleError)
      )
  }

  getProperties(limit: any): Observable<any> {
    return this.http.post<any>(MANAGEMENT_API_URL + "/properties/list", limit, { headers })
      .pipe(
        catchError(this.handleError)
      )
  }
  savePropertiesEntry(property: any){
    return this.http.post(MANAGEMENT_API_URL + "/properties/save", property, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }
  logLevelServices(className: string, logLevel?: string): Observable<any>{
    if(logLevel){
      return this.http.get(MANAGEMENT_API_URL + `/logging/level/set?loggerClassName=${className}&level=${logLevel}`, {headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
    }
    else{
      const httpParams = new HttpParams().append("loggerClassName", className);
      return this.http.get(MANAGEMENT_API_URL + "/logging/level", { headers, responseType:'text', params: httpParams})
      .pipe(
        catchError(this.handleError)
      )
    }
  
  }

  getScheduler(taskName: string){
    return this.http.get(MANAGEMENT_API_URL + "/getScheduler?taskName=" + taskName, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }

  getDBCleanerDays(): Observable<any>{
    return this.http.get(MANAGEMENT_API_URL + "/getDbCleanerDays", { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }

  changeDBCleanerDays(dbCleanerDays : number){
    return this.http.get(MANAGEMENT_API_URL + "/changeDbCleanerDays?dbCleanerDays=" + dbCleanerDays, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }

  getCommonServiceValidationStatus(): Observable<any>{
    return this.http.get(MANAGEMENT_API_URL + "/getCommonServicesSignature", { headers })
      .pipe(
        catchError(this.handleError)
      )
  }

  changeCommonServiceValidation(status: boolean){
    return this.http.get(MANAGEMENT_API_URL + "/changeCommonServicesSignature?param=" + status, { headers, responseType:'text'})
      .pipe(
        catchError(this.handleError)
      )
  }

  getPropertyTypes(): Observable<any> {
    return this.http.get<any>(MANAGEMENT_API_URL + "/properties/types", {headers})
      .pipe(
        catchError(this.handleError)
      )
  }

  getAllServiceLists(): Observable<any> {
    return this.http.get<any>(MANAGEMENT_API_URL + "/services/listAll").pipe(
      catchError(this.handleError)
    )
  }

  getServiceListByType(type:string): Observable<any>{
    return this.http.get(MANAGEMENT_API_URL + `/services/listByType?type=${type}`, {headers})
      .pipe(
        catchError(this.handleError)
      )
  }

  saveProcedure(procedure: any){
    return this.http.post<any>(MANAGEMENT_API_URL + "/services/saveProcedure", procedure).pipe(
      catchError(this.handleError)
    )
  }

  saveRequirement(requirement: any){
    return this.http.post<any>(MANAGEMENT_API_URL + "/services/saveRequirement", requirement).pipe(
      catchError(this.handleError)
    )
  }

  saveProcedureRequirement(procedureRequirement: any){
    return this.http.post<any>(MANAGEMENT_API_URL + "/services/saveProcedureRequirement", procedureRequirement).pipe(
      catchError(this.handleError)
    )
  }

  savePidServiceCatalog(pidServiceCatalog: any){
    return this.http.post<any>(MANAGEMENT_API_URL + "/services/savePidServiceCatalog", pidServiceCatalog).pipe(
      catchError(this.handleError)
    )
  }

  saveRequirementPidCatalog(requirementPidCatalog: any){
    return this.http.post<any>(MANAGEMENT_API_URL + "/services/saveRequirementPidCatalog", requirementPidCatalog).pipe(
      catchError(this.handleError)
    )
  }

  deleteByIdAndType(type:string, id:number): Observable<any>{
    return this.http.get(MANAGEMENT_API_URL + `/services/deleteEntry?type=${type}&id=${id}`, {headers})
      .pipe(
        catchError(this.handleError)
      )
  }

  listAllTemplates(): Observable<any>{
    return this.http.get(MANAGEMENT_API_URL + `/template/getList`)
  }

  updateTemplate(id: number, template: any) {

    return this.http.post(MANAGEMENT_API_URL + `/template/update?id=${id}`, template).pipe(
      catchError(this.handleError)
    )
  }

  saveTemplate(template: any) {
    return this.http.post(MANAGEMENT_API_URL + `/template/save`, template).pipe(
      catchError(this.handleError)
    )
  }
    
}
